import { constantRoutes } from "@/router";
import menuRoutes from "@/router/modules/menu";

/**
 * @description 判断是否有权限
 * @param roles
 * @param route
 */
function hasPermission(route, { roles, experiences, isCompany }) {
    let result = true;
    if (route.meta && route.meta.roles) {
        result = roles.some((role) => route.meta.roles.includes(role));
    } else if (route.meta && route.meta.experiences&&route.meta.experiences.length>0) {
        result = experiences.some((experience) =>
            route.meta.experiences.includes(experience),
        );
    }
    // 判断一下是否有体验权限，有才去判断是否仅公司展示，不然会导致没权限也能看到仅公司身份展示的菜单了
    if (route.meta && route.meta.onlyCompany && result === true) {
        // 有些菜单仅限公司身份访问
        result = isCompany;
    }
    return result;
}

/**
 * 通过递归过滤路由表
 * @param routes constantRoutes
 * @param options
 */
export function filterRoutes(routes, options) {
    const res = [];

    routes.forEach((route) => {
        const tmp = { ...route };
        if (hasPermission(tmp, options)) {
            if (tmp.children) {
                tmp.children = filterRoutes(tmp.children, options);
            }
            res.push(tmp);
        }
    });

    return res;
}

const state = {
    routes: [],
    menuRoutes: [],
};

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.routes = constantRoutes.concat(routes);
    },
    SET_MEAU_ROUTES: (state, routes) => {
        state.menuRoutes = routes;
    },
};

const actions = {
    generateRoutes({ commit }, options) {
        return new Promise((resolve) => {
            // 过滤常驻路由
            const accessedRoutes = filterRoutes(constantRoutes, options);
            commit("SET_ROUTES", accessedRoutes);
            // 过滤菜单路由
            const accessMenuRoutes = filterRoutes(menuRoutes.children, options);
            commit("SET_MEAU_ROUTES", accessMenuRoutes);
            resolve(accessedRoutes);
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
